
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFCA2D","d":"M10 20a6 6 0 016-6h48a6 6 0 016 6v1.1a6 6 0 01-6 6H16a6 6 0 01-6-6V20zm6.75 19.1a6 6 0 016-6h34.67a6 6 0 016 6v1.08a6 6 0 01-6 6H22.75a6 6 0 01-6-6V39.1z"}}),_c('path',{attrs:{"fill":"#F2994A","d":"M26.5 58.18a6 6 0 016-6h14.67a6 6 0 016 6v1.1a6 6 0 01-6 6H32.5a6 6 0 01-6-6v-1.1z"}})])
          )
        }
      }
    